import { render } from "./Delivery.vue?vue&type=template&id=31791c5e"
import script from "./Delivery.vue?vue&type=script&lang=js"
export * from "./Delivery.vue?vue&type=script&lang=js"

import "./Delivery.vue?vue&type=style&index=0&id=31791c5e&lang=css"
script.render = render

export default script